import type { OfferApi } from '@fourthwall/services/dist/OffersApiClient'
import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'
import type { UseInfiniteQueryOptions } from '@tanstack/react-query'
import { useInfiniteQuery } from '@tanstack/react-query'

export const useOffersInfiniteQuery = (
  params?: OfferApi.GetOffersParams,
  options?: UseInfiniteQueryOptions<OfferApi.GetOffersResponse>,
) => {
  const offersInfiniteQuery = useInfiniteQuery<OfferApi.GetOffersResponse>(
    ['offersInfinite', params],
    async ({ pageParam = 0 }) => {
      const { data } = await OffersApiClient.getOffers({ ...params, page: pageParam })

      return data
    },
    {
      getNextPageParam: ({ page: { hasNextPage, pageNumber } }) => hasNextPage && pageNumber + 1,
      select: (data) => {
        data.pages[0].offers = data.pages[0].offers.map((offer) => ({
          ...offer,
          name: decodeHtmlEntities(offer.name),
        }))

        return data
      },
      ...options,
    },
  )

  return {
    offersInfiniteQuery,
  }
}
